import { ko } from "src/i18n/ko";
// import { en } from "src/i18n/en";

export default {
  ko: ko,
  // en: en,
};
